export default {
  title: {
    id: 'bo_sellers-orders-sub_views-no_results_title',
    defaultMessage: 'No orders were found with those filters!',
  },
  description: {
    id: 'bo_sellers-orders-sub_views-no_results_description',
    defaultMessage: 'No results!',
  },
}
